import dayjs from '@util/dayjs'

export const birthdayMax = dayjs().subtract(18, 'year')
